import {ExpandableContentDefinition} from './expandableContent'

export {ExpandableContentDefinition}
